import { Component, Input, Output, EventEmitter, OnChanges } from '@angular/core';

import { PoComponentsModule, PoFieldModule } from "@po-ui/ng-components";
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-pagination',
  standalone: true,
  imports: [PoComponentsModule, PoFieldModule, FormsModule],
  templateUrl: './pagination.component.html',
  styleUrls: ['./pagination.component.css']
})
export class PaginationComponent implements OnChanges {
  @Input() pCurrentPage: number = 1;
  @Input() pTotalItems: number = 1;
  @Input() pTotalPages: number = 1;
  @Input() pPageSize: number = 10;
  @Output() pChangePage: EventEmitter<{ page: number; pageSize: number }> = new EventEmitter();
  visiblePages: Array<number> = [];
  isMobile: boolean = window.innerWidth <= 768;
  pageSizeOptions: Array<{ label: string; value: number }> = [
    { label: '10', value: 10 },
    { label: '20', value: 20 },
    { label: '50', value: 50 },
    { label: '100', value: 100 }
  ];
  startPage: number = 1;
  endPage: number = this.pPageSize;
  
  ngOnChanges() {
    this.calculateVisiblePages();
  }

  calculateVisiblePages() {
    const total = this.pTotalPages;
    const current = this.pCurrentPage;
    const pages: Array<number> = [];

    if (total <= 5) {
      for (let i = 1; i <= total; i++) pages.push(i);
    } else {
      pages.push(1);
      if (current > 3) pages.push(-1);
      for (let i = Math.max(2, current - 1); i <= Math.min(total - 1, current + 1); i++) {
        if (!pages.includes(i)) pages.push(i);
      }
      if (current < total - 2) pages.push(-2);
      if (!pages.includes(total)) pages.push(total);
    }

    this.visiblePages = pages;
    if (this.endPage > this.pTotalItems && this.pTotalItems > 0) this.endPage = this.pTotalItems;
  }

  changePage(page: number, pageSize: number) {
    if (page >= 1 && page <= this.pTotalPages && (page !== this.pCurrentPage || pageSize !== this.pPageSize)) {
      if (pageSize !== this.pPageSize) {
        this.pCurrentPage = 1;
      }

      this.startPage = (page - 1) * pageSize + 1;
      this.endPage = (this.startPage + pageSize - 1);
      if (this.endPage > this.pTotalItems && this.pTotalItems > 0) this.endPage = this.pTotalItems;

      this.pChangePage.emit({ page, pageSize });
    }
  }
}